import { cn } from '../lib/cn';

/** − qty + stepper matching the menu cards in the design. */
export function QtyStepper({
  qty,
  onInc,
  onDec,
  className
}: {
  qty: number;
  onInc: () => void;
  onDec: () => void;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-3 rounded-lg border-[1.5px] border-border px-2.5 py-1',
        className
      )}
    >
      <button
        type='button'
        onClick={onDec}
        aria-label='Decrease quantity'
        className='font-extrabold text-primary'
      >
        −
      </button>
      <b className='min-w-[14px] text-center font-display text-[12.5px] text-content-primary'>{qty}</b>
      <button
        type='button'
        onClick={onInc}
        aria-label='Increase quantity'
        className='font-extrabold text-primary'
      >
        +
      </button>
    </span>
  );
}
